import { baseApi } from 'api/base';
import { BaseDictOption } from 'api/dict/params';
import { EditType, FindFnParams, CatalogName } from '../types/api';

const find = async <D, F, S>(
  catalogName: CatalogName,
  params: FindFnParams<F, S>
): Promise<D[]> => {
  const res = await baseApi.get(`/catalogs/${catalogName}`, {
    params: {
      sort: params.sorting,
      filter: params.filter,
    },
  });
  return res.data.content;
};

const findAll = async <D = BaseDictOption>(catalogName: CatalogName): Promise<D[]> => {
  const res = await baseApi.get(`/catalogs/${catalogName}/all`);
  return res.data;
};

const create = async <D>(catalogName: CatalogName, record: D): Promise<void> => {
  await baseApi.post(`/catalogs/${catalogName}`, record);
};

const update = async <D>(catalogName: CatalogName, record: EditType<D>): Promise<void> => {
  await baseApi.post(`/catalogs/${catalogName}`, record);
};

const remove = async (catalogName: CatalogName, id: string): Promise<void> => {
  await baseApi.delete(`/catalogs/${catalogName}/${id}`);
};

export const catalogsApi = {
  find,
  findAll,
  create,
  update,
  remove,
};
